import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => ({
  tableId: '',
  queries: [
    {
      outputPlaceholder: 'query_result',
      select: { mode: 'all', columns: [] },
      where: { groups: [] },
      orderBy: { column: '', direction: 'ASC' },
      limit: 500,
      outputFormat: 'rows',
      outputColumn: '',
      aggregates: [],
    },
  ],
});

const onLoadData = (data) => {
  return {
    tableId: data?.tableId || '',
    queries: data?.queries || initData().queries,
  };
};

const { getStore: getQueryTableV2Store, defaultStore } = createComponentStore({
  type: 'query_table_v2',
  endpoint: 'query_table_v2',
  registryKey: 'query_table_v2',
  initData,
  onLoadData,
});

export { getQueryTableV2Store, defaultStore };
export default defaultStore;
